export const LOGIN_ANOTHER_WAY_REQUEST = "LOGIN_ANOTHER_WAY_REQUEST";
export const LOGIN_ANOTHER_WAY_SUCCESS = "LOGIN_ANOTHER_WAY_SUCCESS";
export const LOGIN_ANOTHER_WAY_FAILURE = "LOGIN_ANOTHER_WAY_FAILURE";
export const RESET_LOGIN_ANOTHER_WAY_STATE = "RESET_LOGIN_ANOTHER_WAY_STATE";
